import { defineAppPlugin } from '@/main';

import type { MessageParams, NotificationParams } from 'element-plus';

const ElNotificationLoader = async () => {
  const [{ default: ElNotification }] = await Promise.all([
    import('element-plus/es/components/notification/index'), // 動態導入元件
    import('element-plus/es/components/notification/style/css'), // 動態載入樣式
  ]);
  return ElNotification;
};

const ElMessageLoader = async () => {
  const [{ default: ElMessage }] = await Promise.all([
    import('element-plus/es/components/message/index'), // 動態導入元件
    import('element-plus/es/components/message/style/css'), // 動態載入樣式
  ]);
  return ElMessage;
};

const notify = async (options: NotificationParams) => {
  const ElNotification = await ElNotificationLoader();
  ElNotification(options);
};

const message = async (options: MessageParams) => {
  const ElMessage = await ElMessageLoader();
  ElMessage(options);
};

export default defineAppPlugin(() => {
  return {
    provide: {
      notify,
      message,
    },
  };
});

declare module 'src/main' {
  interface Context {
    /**
     * Displays a global notification message at a corner of the page.
     *
     * @see https://element-plus.org/en-US/component/notification.html
     */
    $notify: typeof notify;

    /**
     * Used to show feedback after an activity. The difference with Notification is that the latter is often used to show a system level passive notification.
     *
     * @see https://element-plus.org/en-US/component/message.html
     */
    $message: typeof message;
  }
}
